import * as React from 'react'
import { Text } from '@doordash/design-language'
import { SectionContainer, ContentText } from '../../StyleComponents'
import {
  BulletList,
  NumericList,
  BulletListItem,
  ImageContainer,
} from '../../styles'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'
import { MotorcycleSafetySexualHarassmentImage } from '../../images/MotorcycleSafetySexualHarassmentImage'

export const SexualHarassmentSection = () => {
  return (
    <SectionContainer>
      <ImageContainer>
        <MotorcycleSafetySexualHarassmentImage />
      </ImageContainer>
      <Text styles={Text.Styles.Bold32}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__online_safety_course__sexual_harassment
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__sexual_harassment_on_the_doordash_platform_is_strictly_prohibited_we000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__if_you_experience_harassment_from_a_customer_another_dasher_or001
        )}
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__what_constitutes_sexual_harassment
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__sexual_harassment_includes_visual_verbal_or_physical_misconduct_of_a000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__the_following_behaviors_may_constitute_sexual_harassment001
        )}
      </ContentText>

      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__unwanted_flirting_and_sexual_advances,
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__retaliation_or_threat_of_retaliation_after_a_negative_response_to,
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__leering_making_sexual_gestures_or_displaying_sexually_suggestive_objects_pictures,
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__derogatory_sexualised_comments_epithets_slurs_or_sexually_explicit_jokes_comments,
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__touching_assault_impeding_or_blocking_movements,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__protection_against_retaliation
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__doordash_prohibits_retaliation_for_making_a_goodfaith_complaint_of_harassment
        )}
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__process_for_reporting_sexual_harassment_complaints
        )}
      </Text>
      <NumericList>
        {[
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__go_to_helpdoordashcom000,
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__select_dasher_support_then_email_us001,
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__choose_health_safety_or_legal_concern002,
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__in_the_description_include_as_much_information_you_feel_comfortable003,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </NumericList>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__what_to_expect_when_reporting_sexual_harassment_complaints
        )}
      </Text>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__well_maintain_confidentiality_surrounding_the_investigation_to_the_extent_possible,
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__well_conduct_a_fair_timely_thorough_and_impartial_investigation_that,
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__we_expect_anyone_using_doordash_to_fully_cooperate_with_any,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__concluding_the_investigation
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step4__sexual_harassment__when_the_investigation_is_complete_we_will_communicate_the_outcome
        )}
      </ContentText>
    </SectionContainer>
  )
}
